var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xxxx",attrs:{"name":"nnn"}},[_vm._v(" 近期有诈骗份子冒充暗签平台skype账号进行诈骗。我们不会泄露客户信息，也不会随意去添加客户。请认准官方唯一指定账户skype：1052500005. 纸飞机：@ios6868. ")])}
var staticRenderFns = []

export { render, staticRenderFns }